import { AuthTokenModel } from './../../common/interfaces/global-interfaces';
import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";
import {Router} from "@angular/router";
import {UserManagementService} from "../../services/user-management.service";
import {AccountTypeEnum} from "../../common/interfaces/global-interfaces";
import {StorageService} from "../../services/storage.service";



@Component({
  selector: 'app-login-with-gms',
  standalone: false,
  templateUrl: './login-with-gms.component.html',
  styleUrl: './login-with-gms.component.scss'
})
export class LoginWithGmsComponent {
  form: FormGroup;
  hide = true;
  loading = false;
  private fb: FormBuilder = inject(FormBuilder)
  private authService: AuthService = inject(AuthService)
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);
  private uaaService: UserManagementService = inject(UserManagementService)
  private storageService = inject(StorageService);

  constructor() {
  }

  ngOnInit() {
    this.form = this.fb.group({
      gmsEmail: [null, Validators.required],
      phoneNumber:[null,Validators.required],
    });
  }

  navigateTo(route:string[]){
  this.router.navigate(route)
}


async login(formValue: any) {
  this.loading = true;

  try {
     await this.authService.loginWithGMS(formValue);

  } catch (e: any) {
    this.notificationService.errorMessage('Action failed, please try again.');
  } finally {
    this.loading = false;
  }
}
}
